export default __webpack_public_path__ + "static/media/18.70060302.jpg";